import React, { useEffect, useState } from "react";
import SubscriptionBox from "../../components/Subscription/SubscriptionBox";
import ExpandLeft from "../../assets/icons/ExpandWhiteLeft";
import HeroImage from "../../assets/icons/svgicons/SubscriptionHeroImage.svg";
import { useUserStore } from "../../state";
import { createSubscriptionPaymentLink } from "../../backend-services/subscription";
import { Link } from "react-router-dom";
import sales from "../../components/Images/Ellipse1437.webp";
import { useTranslation } from "react-i18next";
import { CloseIcon } from "../../assets/icons";
import { useSubscription } from "../../context/SubscriptionProvider";

interface SubscriptionPageProps {
  close: () => void; // Function to close the modal
}

const SubscriptionPage: React.FC<SubscriptionPageProps> = ({ close }) => {
  const { t } = useTranslation("subscription");
  const [price, setPrice] = useState<number>(0);
  const [email, setEmail] = useState<string>("");
  const [companyId, setCompanyId] = useState<string>("");
  const [subscriptionId, setSubscriptionId] = useState<number>(0);
  const [plan, setPlan] = useState<string>("");
  const [isChoosing, setIsChoosing] = useState<boolean>(false);
  const [indexState, setIndexState] = useState<number | null>(null);
  const { subscription: subscriptionData, refresh } = useSubscription();
  const { user } = useUserStore((state) => ({ user: state.user }));

  // const { subscriptionList, fetchListSubscription, isLoading } =
  //   useSubscriptionStore((state) => ({
  //     subscriptionList: state.subscriptionList,
  //     subscription: state.subscription,
  //     fetchListSubscription: state.fetchListSubscription,
  //     isLoading: state.isLoading,
  //   }));

  // useEffect(() => {
  //   fetchListSubscription();
  //   setEmail(user.email!);
  //   setCompanyId(user.id!);
  // }, [fetchListSubscription, user]);



  return (
    <div className="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center z-50 backdrop-blur-sm ">
      <div className="bg-white md:rounded-[20px] w-full max-w-5xl scroll-container md:max-h-[90vh] 2xl:max-h-auto  max-h-screen pb-10">
        <div className="relative bg-[#E0EEFE] overflow-hidden text-center">
          <button
            className="absolute right-10 top-[50px] hidden md:flex"
            onClick={close}
          >
            <CloseIcon height="40" width="40" />
          </button>

          <button
            className="absolute right-10 top-[50px]  md:hidden flex"
            onClick={close}
          >
            <CloseIcon height="30" width="30" />
          </button>

          <div className=" text-center flex flex-col justify-center items-center md:mt-[58px] mt-[50px]">
            <h1 className="md:text-[48px] text-[20px] font-bold text-[#0D3C6D] font-recoleta">
              Everything You Need. <br />
              Nothing You Don't
            </h1>
            <p className="md:text-lg mt-2 w-[376px]">
              Unlock Esemié’s exclusive features and give your business the
              prime boost it deserves.
            </p>
          </div>

          <div className="lg:mt-[32px] w-full bg-white  pt-10">
            <SubscriptionBox isChoosing={isChoosing} indexState={indexState} />
          </div>
          <div className="bg-white absolute h-[80vh] bottom-0 w-full pb-10 hidden md:flex"></div>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionPage;
